import { YOO_FINDS_CDN } from "@/common";

const ROOT = `${YOO_FINDS_CDN}/h5/sample-authorized`;

export const SAMPLE_AUTHORIZED_LEFT_BG = `${ROOT}/bg.png`;
export const SAMPLE_AUTHORIZED_RIGHT_BG = `${ROOT}/bg-right.png`;
export const SAMPLE_AUTHORIZED_STEP1 = `${ROOT}/sample-authorized-step05.png`;
export const SAMPLE_AUTHORIZED_STEP2 = `${ROOT}/sample-authorized-step6-v1.png`;
